import logout from './logout'
import { MARGIN_ACCESS_EXPIRATION, auth_api_uri } from '../config/Auth0'
import { getDeviceId } from '../utils'

let refreshPromise = null

export default async function getAccessToken({ force = false } = {}) {
  // Migration guard: clear old localStorage-based sessions
  if (localStorage.getItem('credentials')) {
    localStorage.removeItem('credentials')
    localStorage.removeItem('user')
    localStorage.removeItem('expiration')
    localStorage.removeItem('appState')
    return null
  }

  const marginExpiration = MARGIN_ACCESS_EXPIRATION
  const expiration = localStorage.getItem('expiration')

  if (!expiration) return null

  const actualTime = Math.floor(Date.now() / 1000)
  if (force || actualTime >= expiration - marginExpiration) {
    // Deduplicate concurrent refresh calls
    if (refreshPromise) return refreshPromise

    refreshPromise = (async () => {
      try {
        const deviceId = await getDeviceId()
        const response = await fetch(`${auth_api_uri}/api/auth/refresh`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Client': 'web'
          },
          credentials: 'include',
          body: JSON.stringify({
            device_id: deviceId
          })
        })
        if (response.ok) {
          const { user, expires } = await response.json()
          localStorage.setItem('expiration', String(expires))
          localStorage.setItem('user', JSON.stringify(user))
          return true
        } else if (response.status === 401) {
          logout({ returnTo: window.location.href })
          return null
        } else {
          console.error('Token refresh failed:', response.status)
          return null
        }
      } catch (error) {
        console.error('Token refresh error:', error)
        return null
      } finally {
        refreshPromise = null
      }
    })()

    return refreshPromise
  }

  return true
}
